// extracted by mini-css-extract-plugin
module.exports = {"title":"_3oJnj","text":"SI5ux"};